module.exports = __webpack_public_path__ + "img/subject.1c5ab8cb.png";